import React from 'react';

interface LoadingSpinnerProps {
  message?: string;
  fullPage?: boolean;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  message = 'Lädt...',
  fullPage = false
}) => {
  const containerStyle: React.CSSProperties = fullPage
    ? {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        padding: '40px'
      }
    : {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '40px'
      };

  return (
    <div style={containerStyle}>
      <div
        className="spinner-border text-primary"
        role="status"
        style={{ width: '3rem', height: '3rem', borderWidth: '0.3em' }}
      >
        <span className="visually-hidden">Loading...</span>
      </div>
      <p style={{
        marginTop: '20px',
        color: '#687088',
        fontSize: '16px',
        fontWeight: 500
      }}>
        {message}
      </p>
    </div>
  );
};

export default LoadingSpinner;
